import { render, staticRenderFns } from "./DevMapShow.vue?vue&type=template&id=7c20ff70&scoped=true&"
import script from "./DevMapShow.vue?vue&type=script&lang=js&"
export * from "./DevMapShow.vue?vue&type=script&lang=js&"
import style0 from "./DevMapShow.vue?vue&type=style&index=0&id=7c20ff70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c20ff70",
  null
  
)

export default component.exports